import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.setActiveLinks();
  }

  setActiveLinks() {
    const currentPathname = window.location.pathname;
    const currentPaths = currentPathname.split("/");

    // First check for regex patterns in data-nested-paths
    const linksWithNestedPaths = this.element.querySelectorAll(
      "a[data-nested-paths]"
    );
    let matchedLink = null;

    for (const link of linksWithNestedPaths) {
      const nestedPathsValue = link.dataset.nestedPaths;
      const nestedPaths = nestedPathsValue.split(/\s+/);

      // Check each path, which could be a regex pattern (wrapped in /)
      for (const path of nestedPaths) {
        if (path.startsWith("/")) {
          const lastSlashIndex = path.lastIndexOf("/");
          // Ensure there is at least one character between the slashes (e.g., '/foo/i')
          if (lastSlashIndex > 1) {
            const pattern = path.substring(1, lastSlashIndex);
            const flags = path.substring(lastSlashIndex + 1);

            try {
              const regex = new RegExp(pattern, flags);
              if (regex.test(currentPathname)) {
                matchedLink = link;
                break;
              }
            } catch (e) {
              console.warn(
                "Invalid regex pattern in data-nested-paths:",
                path,
                e
              );
            }
          }
        }
      }

      if (matchedLink) break;
    }

    // If no regex match, fall back to the original path segment matching
    if (!matchedLink) {
      currentPaths.forEach((currentPath) => {
        if (!currentPath) return; // Skip empty segments

        // First check href exact match
        const hrefMatch = this.element.querySelector(
          `a[href$='${currentPath}']`
        );
        if (hrefMatch) {
          matchedLink = hrefMatch;
          return;
        }

        // For data-nested-paths, check word boundaries to avoid substring matches
        const linksWithPaths = this.element.querySelectorAll(
          "a[data-nested-paths]"
        );
        for (const link of linksWithPaths) {
          const paths = link.dataset.nestedPaths.split(/\s+/);
          if (paths.includes(currentPath)) {
            matchedLink = link;
            return;
          }
        }
      });
    }

    // Apply the active class
    if (matchedLink) {
      Array.from(this.element.querySelectorAll("li.active")).forEach((e) =>
        e.classList.remove("active")
      );
      matchedLink.closest("li").classList.add("active");
    }
  }
}
